/**
 * Turnover (cleaning-window) codes — tasks/arrival-readiness-action-side.md Phase 2.
 *
 * Must match be/utils/errors.js (Turnover group) and WINDOW_STATUS / VERDICT in
 * be/utils/turnoverWindow.js and be/services/turnover/guard.js.
 *
 * Client rule: branch on these, never on the Arabic text beside them.
 */
export const TURNOVER_ERROR_CODES = {
  // The save would expect the next guest before the last one has left. Not overridable — the
  // way through is recording the previous guest's actual checkout.
  WINDOW_NEGATIVE: 'TURNOVER_001'
};

export const WINDOW_STATUS = {
  COMFORTABLE: 'comfortable',
  TIGHT: 'tight',
  NEGATIVE: 'negative',
  UNKNOWN: 'unknown',
  NOT_APPLICABLE: 'not_applicable'
};

export const TURNOVER_VERDICT = {
  OK: 'ok',
  WARN: 'warn',
  BLOCK: 'block'
};
